import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { borderPrimary, cardBg, primaryText } from '../../styling/stylingHelper';

export type AnswerUnit = 'g' | 'kg' | 'ml' | 'l' | 'p';
export interface AnswerAmount { value: number; unit: AnswerUnit }
export function AmountInput({ value, onChange, label, disabled = false, units = ['g', 'kg', 'ml', 'l', 'p'] }: {
  value?: AnswerAmount; onChange: (amount: AnswerAmount | undefined) => void;
  label: string; disabled?: boolean; units?: AnswerUnit[];
}) {
  const { t } = useTranslation();
  const [text, setText] = useState(value ? String(value.value) : '');
  const [unit, setUnit] = useState<AnswerUnit>(value?.unit ?? units[0]);
  useEffect(() => {
    if (value && Number(text.replace(',', '.')) !== value.value) setText(String(value.value));
    if (value && value.unit !== unit) setUnit(value.unit);
    // Local text retains a partially entered decimal while the parent holds the numeric value.
  }, [value, text, unit]);
  const change = (raw: string, nextUnit: AnswerUnit) => {
    setText(raw); setUnit(nextUnit);
    const amount = Number(raw.trim().replace(',', '.'));
    onChange(raw.trim() && Number.isFinite(amount) && amount > 0 ? { value: amount, unit: nextUnit } : undefined);
  };
  return <div className="flex flex-wrap items-end gap-2">
    <label className="flex min-w-0 flex-1 flex-col gap-1 text-sm">
      <span>{label}</span>
      <input type="text" inputMode="decimal" value={text} disabled={disabled} required
        onChange={event => change(event.target.value, unit)}
        className={`w-full min-w-20 rounded-lg border px-3 py-2 ${borderPrimary} ${cardBg} ${primaryText}`} />
    </label>
    <label className="flex flex-col gap-1 text-sm">
      <span>{t('customerRequests.unit')}</span>
      <select value={unit} disabled={disabled} onChange={event => change(text, event.target.value as AnswerUnit)}
        className={`rounded-lg border px-2 py-2 ${borderPrimary} ${cardBg} ${primaryText}`}>
        {units.map(item => <option key={item} value={item}>{item === 'p' ? t('customerRequests.pieces') : item === 'l' ? 'L' : item}</option>)}
      </select>
    </label>
  </div>;
}
